import { Routes, RouterModule } from '@angular/router';
import { PrivilegeGuard } from '../auth/privilege-guard.service';

//Route for content layout with sidebar, navbar and footer.

export const Full_ROUTES: Routes = [
  {
    path: 'accounting',
    loadChildren: () => import('../../accounting/accounting.module').then(m => m.AccountingModule)
  },
  {
    path: 'analytics',
    loadChildren: () => import('../../analytics/analytics.module').then(m => m.AnalyticsModule)
  },
  {
    path: 'reporting',
    canActivate: [PrivilegeGuard],
    data: { requiredPrivileges: ['REPORT_VIEW'] },
    loadChildren: () => import('../../reporting/reporting.module').then(m => m.ReportingModule)
  },
  {
    path: 'transactions',
    canActivate: [PrivilegeGuard],
    data: { requiredPrivileges: ['TRANSACTION_VIEW_ALL'] },
    loadChildren: () => import('../../transactions/transactions.module').then(m => m.TransactionsModule)
  },
  {
    path: 'fx',
    canActivate: [PrivilegeGuard],
    data: { requiredPrivileges: ['FX_RATE_VIEW'] },
    loadChildren: () => import('../../fx/fx.module').then(m => m.FxModule)
  },
  {
    path: 'portal/onboarding',
    data: { audience: 'onboarding' },
    loadChildren: () => import('../../onboarding-v2/onboarding-v2.module').then(m => m.OnboardingV2Module)
  },
  {
    path: 'portal',
    canActivate: [PrivilegeGuard],
    data: { requiredPrivileges: ['TRANSACTION_VIEW', 'CLIENT_CREDENTIAL_VIEW', 'CLIENT_SECRET_REGENERATE', 'FUNDING_REQUEST_VIEW'], audience: 'portal' },
    loadChildren: () => import('../../portal/portal.module').then(m => m.PortalModule)
  },
  {
    path: 'approvisionnements',
    canActivate: [PrivilegeGuard],
    data: { requiredPrivileges: ['FUNDING_REQUEST_VIEW'] },
    loadChildren: () => import('../../funding-requests-admin/funding-requests-admin.module').then(m => m.FundingRequestsAdminModule)
  },
  {
    path: 'portal-settings',
    canActivate: [PrivilegeGuard],
    data: { requiredPrivileges: ['CLIENT_SETTINGS_VIEW'], audience: 'portal' },
    loadChildren: () => import('../../portal-settings/portal-settings.module').then(m => m.PortalSettingsModule)
  },
  {
    path: 'partners',
    canActivate: [PrivilegeGuard],
    data: {
      audience: 'admin',
      requiredPrivileges: [
        'PARTNER_VIEW', 'PARTNER_CREATE', 'PARTNER_UPDATE',
        'PARTNER_PAYMENT_SERVICE_VIEW', 'PARTNER_PAYMENT_SERVICE_CREATE', 'PARTNER_PAYMENT_SERVICE_UPDATE'
      ]
    },
    loadChildren: () => import('../../partners/partners.module').then(m => m.PartnersModule)
  },
  // Legacy misspelled URL kept as redirects so existing bookmarks keep working.
  {
    path: 'parthners',
    children: [
      { path: '', pathMatch: 'full', redirectTo: '/partners/all' },
      { path: 'fees/edit/:id', pathMatch: 'full', redirectTo: '/partners/fees/edit/:id' },
      { path: 'payment-services/edit/:id', pathMatch: 'full', redirectTo: '/partners/payment-services/edit/:id' },
      { path: 'details/:id', pathMatch: 'full', redirectTo: '/partners/details/:id' },
      { path: 'edit/:id', pathMatch: 'full', redirectTo: '/partners/edit/:id' },
      { path: 'all', pathMatch: 'full', redirectTo: '/partners/all' },
      { path: 'fees', pathMatch: 'full', redirectTo: '/partners/fees' },
      { path: 'fees/create', pathMatch: 'full', redirectTo: '/partners/fees/create' },
      { path: 'payment-services', pathMatch: 'full', redirectTo: '/partners/payment-services' },
      { path: 'payment-services/create', pathMatch: 'full', redirectTo: '/partners/payment-services/create' },
      { path: 'create', pathMatch: 'full', redirectTo: '/partners/create' }
    ]
  },
  {
    path: 'users',
    canActivate: [PrivilegeGuard],
    data: { requiredPrivileges: ['USER_VIEW'], audience: 'admin' },
    loadChildren: () => import('../../users/users.module').then(m => m.UsersModule)
  },
  {
    path: 'settings',
    canActivate: [PrivilegeGuard],
    data: { requiredPrivileges: ['SETTINGS_VIEW'], audience: 'admin' },
    loadChildren: () => import('../../settings/settings.module').then(m => m.SettingsModule)
  },
  {
    path: 'customers',
    canActivate: [PrivilegeGuard],
    data: { audience: 'admin', requiredPrivileges: ['CLIENT_VIEW', 'CLIENT_CREATE'] },
    loadChildren: () => import('../../customers/customers.module').then(m => m.CustomersModule)
  },
  {
    path: 'preferences',
    canActivate: [PrivilegeGuard],
    data: {
      audience: 'admin',
      requiredPrivileges: [
        'CURRENCY_VIEW', 'CURRENCY_CREATE', 'CURRENCY_UPDATE',
        'COUNTRY_VIEW', 'COUNTRY_CREATE', 'COUNTRY_UPDATE',
        'PAYMENT_SERVICE_VIEW', 'PAYMENT_SERVICE_CREATE', 'PAYMENT_SERVICE_UPDATE',
        'COUNTRY_PAYMENT_SERVICE_VIEW', 'COUNTRY_PAYMENT_SERVICE_CREATE', 'COUNTRY_PAYMENT_SERVICE_UPDATE',
        'ROLE_VIEW'
      ]
    },
    loadChildren: () => import('../../preferences/preferences.module').then(m => m.PreferencesModule)
  },
  {
    path: 'dashboard',
    loadChildren: () => import('../../dashboard/dashboard.module').then(m => m.DashboardModule)
  },
  {
    path: 'calendar',
    loadChildren: () => import('../../calendar/calendar.module').then(m => m.CalendarsModule)
  },
  {
    path: 'charts',
    loadChildren: () => import('../../charts/charts.module').then(m => m.ChartsNg2Module)
  },
  {
    path: 'forms',
    loadChildren: () => import('../../forms/forms.module').then(m => m.FormModule)
  },
  {
    path: 'maps',
    loadChildren: () => import('../../maps/maps.module').then(m => m.MapsModule)
  },
  {
    path: 'tables',
    loadChildren: () => import('../../tables/tables.module').then(m => m.TablesModule)
  },
  {
    path: 'datatables',
    loadChildren: () => import('../../data-tables/data-tables.module').then(m => m.DataTablesModule)
  },
  {
    path: 'uikit',
    loadChildren: () => import('../../ui-kit/ui-kit.module').then(m => m.UIKitModule)
  },
  {
    path: 'components',
    loadChildren: () => import('../../components/ui-components.module').then(m => m.UIComponentsModule)
  },
  {
    path: 'pages',
    loadChildren: () => import('../../pages/full-pages/full-pages.module').then(m => m.FullPagesModule)
  },
  {
    path: 'cards',
    loadChildren: () => import('../../cards/cards.module').then(m => m.CardsModule)
  },
  {
    path: 'chat',
    loadChildren: () => import('../../chat/chat.module').then(m => m.ChatModule)
  },
  {
    path: 'chat-ngrx',
    loadChildren: () => import('../../chat-ngrx/chat-ngrx.module').then(m => m.ChatNGRXModule)
  },
  {
    path: 'inbox',
    loadChildren: () => import('../../inbox/inbox.module').then(m => m.InboxModule)
  },
  {
    path: 'taskboard',
    loadChildren: () => import('../../taskboard/taskboard.module').then(m => m.TaskboardModule)
  },
  {
    path: 'taskboard-ngrx',
    loadChildren: () => import('../../taskboard-ngrx/taskboard-ngrx.module').then(m => m.TaskboardNGRXModule)
  },
  {
    path: 'onboarding-v2',
    canActivate: [PrivilegeGuard],
    data: { audience: 'admin', requiredPrivileges: ['CLIENT_VIEW', 'CLIENT_CREATE'] },
    loadChildren: () => import('../../onboarding-v2/onboarding-v2.module').then(m => m.OnboardingV2Module)
  }
];
